import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { SolicitudService } from '../../../solicitudes/datosbasicos/datosbasicos.service';
import { TUsuarioExternoViewModel } from '../../../solicitudes/datosbasicos/datosbasicos.types';
import { Location } from '@angular/common';

@Component({
    selector: 'app-solicitante-detail',
    templateUrl: './solicitante-detail.component.html',
})
/** pais-list component*/
export class SolicitanteDetailComponent extends ComponentBase implements OnInit {
    /** pais-list ctor */

    solicitante: TUsuarioExternoViewModel;
    IdSolicitud: number;

    public isCollapsedDatosRepresentante = false;
    public isCollapsedDatosContacto = false;
    public isCollapsedDatosOrganizacion = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private fb: UntypedFormBuilder,
        private solicitudService: SolicitudService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        private _location: Location,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.form = this.fb.group({
            Nombre: '',
            Apellidos: '',
            NIF: '',
            NumeroTelefono: '',
            NumeroFax: '',
            Email: '',
            RazonSocial: '',
            IdPaisDescripcion: '',
            Localidad: '',
            NifCifRazonSocial: '',
            IdProvinciaDescripcion: '',
            IdTipoViaDescripcion: '',
            NombreVia: '',
            NumeroPortal: '',
            CodigoPostal: '',
        });

        let id = +this.activatedRoute.snapshot.params['id'];

        this.IdSolicitud = this.solicitudService.currentIdSolicitud;

        this.loading = true;
        this.solicitudService.getSolicitante(id).subscribe(result => {
            this.solicitante = result;
            this.loading = false;

            this.form.setValue({
                Nombre: this.solicitante.Nombre,
                Apellidos: this.solicitante.Apellidos,
                NIF: this.solicitante.NifSolicitante,
                NumeroTelefono: this.solicitante.NumeroTelefono,
                NumeroFax: this.solicitante.NumeroFax,
                Email: this.solicitante.Email,
                RazonSocial: this.solicitante.RazonSocial,
                IdPaisDescripcion: this.solicitante.IdPaisDescripcion,
                Localidad: this.solicitante.Localidad,
                NifCifRazonSocial: this.solicitante.NifCifRazonSocial,
                IdProvinciaDescripcion: this.solicitante.IdProvinciaDescripcion,
                IdTipoViaDescripcion: this.solicitante.IdTipoViaDescripcion,
                NombreVia: this.solicitante.NombreVia,
                NumeroPortal: this.solicitante.NumeroPortal,
                CodigoPostal: this.solicitante.CodigoPostal,
            });
        });
    }

    onBack(): void {
        //Usamos el location ya que hay diferentes formas de llegar aquí­
        this._location.back();
    }
}
